import React from 'react'

const NotFound = () => {
    return(
        <section>
            <p>Maaf, halaman yang kamu tuju tidak tersedia.</p>
            <p>Mungkin kamu belum login?</p>
        </section>
    )
}
export default NotFound